import {GRADE_BAND_RANK} from "./getBreadcrumbProgram";

export const PROGRAM_END_CARD_HELP_KEY = "program-help";
export const PROGRAM_END_CARD_TRACKING_SOURCE = "program_end_card";
export const PROGRAM_END_CARD_EXPLORER_LOCATION = "end_card";
export const PROGRAM_END_CARD_CONTACT_HREF = "/contact-us";

/** Discovery `cta_location` for a program-explorer card on a given page. */
export function programExplorerCtaLocation(location: string): string {
	return `${location}_program_explorer`;
}

export const FALLBACK_PROGRAM_END_CARD_TITLE = "Explore other programs.";
export const FALLBACK_PROGRAM_END_CARD_BODY =
	"Find the right challenge for your student across our offerings.";
export const FALLBACK_PROGRAM_END_CARD_HELP =
	"Have questions? Please {{link}}contact us{{end-link}}.";

export type ProgramEndCardLink = {
	name: string;
	slug: string;
	href: string;
};

type ProgramNavLike = {
	name?: string | null;
	slug?: {current?: string | null} | null;
};

/**
 * Other grade-band programs to show on the program-page end card, ordered
 * lowest → highest with Contest Prep last. Unknown slugs (e.g. Summer) are omitted.
 */
export function getProgramEndCardLinks(
	programs: ProgramNavLike[] | null | undefined,
	currentSlug: string
): ProgramEndCardLink[] {
	if (!programs || programs.length === 0) {
		return [];
	}

	const current = currentSlug.trim();
	const links: ProgramEndCardLink[] = [];

	for (const program of programs) {
		const slug = program.slug?.current?.trim();
		const name = program.name?.trim();
		if (!slug || !name || slug === current) {
			continue;
		}
		if (GRADE_BAND_RANK[slug] === undefined) {
			continue;
		}
		links.push({name, slug, href: `/program/${slug}`});
	}

	return [...links].sort(
		(left, right) => GRADE_BAND_RANK[left.slug]! - GRADE_BAND_RANK[right.slug]!
	);
}
